<template>
    <div class="mt-4 pr-2 pl-2 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
        <v-toolbar elevation="0">
            <v-text-field
                    flat
                    solo
                    prepend-icon="search"
                    placeholder="Type something"
                    v-model="search"
                    hide-details
                    class="hidden-sm-and-down"
            ></v-text-field>
            <v-spacer></v-spacer>
            <div class="mt-6">
                <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="opsitablecashin    .awal"
                                label="Tanggal Awal"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="opsitablecashin.awal" @input="menu1 = false"></v-date-picker>
                </v-menu>
            </div>
            <div class="mt-6">
                <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="opsitablecashin.akhir"
                                label="Tanggal Akhir"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="opsitablecashin.akhir" @input="menu2 = false"></v-date-picker>
                </v-menu>
            </div>
            <v-btn class="ml-2" color="primary" @click.native="getCashin(opsitablecashin)">
                <v-icon dark>refresh</v-icon>Refresh
            </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-data-table
                :headers="headers"
                :search="search"
                :items="cashin"
                class="elevation-0"
                item-key="id"
                :options.sync="opsitablecashin"
                :server-items-length="total_cashin"
                :loading="loading"
                @update:options="getCashin(opsitablecashin)"
        >
            <template v-slot:item.amount="{ item }">
                <div class="">
                    {{formatAngka(item.amount)}}
                </div>
            </template>
            <template v-slot:item.createdat="{ item }">
                {{formatDate(item.createdat)}}
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import moment from "moment";
    import {mapActions, mapState} from "vuex";
    import Utils from "@/plugins/utils";
    export default {
        name: "Cashin",
        data: ()=>({
            search: '',
            menu1: false,
            menu2: false,
            dateawal: moment().add(7,'hours').toISOString().substr(0, 10),
            dateakhir: moment().add(7,'hours').toISOString().substr(0, 10),
            opsitablecashin: {
                search:'',
                itemsPerPage: 10,
                page:1,
                status: "COMPLETED",
                sortBy: ["id"],
                awal: moment().add(7,'hours').toISOString().substr(0, 10),
                akhir: moment().add(7,'hours').toISOString().substr(0, 10),
            },
            headers: [
                {
                    text: 'id',
                    value: 'id'
                },
                {
                    text: 'Time ',
                    value: 'createdat'
                },
                {
                    text: 'Channel',
                    value: 'channel.name'
                },
                {
                    text: 'Amount',
                    value: 'amount'
                },
                {
                    text: 'Fee (Biaya)',
                    value: 'fee'
                },
                {
                    text: 'Description',
                    value: 'description'
                },
                {
                    text: 'Reff',
                    value: 'reff'
                },
            ],
        }),
        mounted(){
          this.getCashin(this.opsitablecashin);
        },
        computed: {
            ...mapState('Wallet',['cashin','loading','total_cashin'])
        },
        methods: {
            ...mapActions('Wallet',['getCashin']),
            formatAngka(val){
                return Utils.formatAngka(val)
            },
            formatDate (value) {
                return moment(value).add(7,'hours').format("YYYY/MM/DD HH:mm:ss")
            },
        }
    }
</script>

<style scoped>

</style>
